import {BaseEntity} from '../../../../shared/models/ApiModels'
import * as Yup from 'yup'

export interface ICurrencyModel extends BaseEntity {
  currencyAbbreviation: string
  exchangeRate: number
  country: string
}

export const initialCurrency: ICurrencyModel = {
  currencyAbbreviation: '',
  exchangeRate: 0,
  country: '',
}

export const validationCurrency = Yup.object().shape({
  currencyAbbreviation: Yup.string().required('Döviz kısaltması zorunludur'),
})
